import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const SectionTitle = ({ icon, title, className }) => (
  <div className={`lead text-muted text-uppercase font-weight-normal mb-3 ${className}`}>
    <FontAwesomeIcon icon={icon} className="mr-2" fixedWidth />
    {title}
  </div>
)

SectionTitle.propTypes = {
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string
}

SectionTitle.defaultProps = {
  className: undefined
}

export default SectionTitle
